import { render, staticRenderFns } from "./settingWebhook.vue?vue&type=template&id=6982b2dc&scoped=true&"
import script from "./settingWebhook.vue?vue&type=script&lang=js&"
export * from "./settingWebhook.vue?vue&type=script&lang=js&"
import style0 from "./settingWebhook.vue?vue&type=style&index=0&id=6982b2dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6982b2dc",
  null
  
)

export default component.exports